import React from 'react';
import { Styled } from './index.styles';
import CurrencyIcon from 'components/currency-icon';
import { NumberFormatDec, NumberFormatInt } from 'common/utils';

interface Props {
    price: any;
    decimal?: boolean;
    symbol?: string;
    fontSize?: number;
    line?: boolean;
    color?: string;
    fontWeight?: boolean;
    currencies?: { key: string; value: number }[];
    currentCurrency?: string;
    symbolIcon?: boolean;
    TRdecimal?: boolean;
    noCalculate?: boolean;
}

const CurrencyPrice: React.FC<Props> = ({
    price,
    decimal = true,
    symbol = 'TRY',
    fontSize,
    line = false,
    color,
    fontWeight,
    currencies = [],
    currentCurrency = 'TRY',
    symbolIcon = false,
    TRdecimal = false,
    noCalculate = false,
}) => {
    const CurrencyPriceCalculate = (
        amount: string | number,
        currencies: { key: string; value: number }[],
        currency: string = 'TRY'
    ) => {
        const selectedCurrency = currencies.find((c) => c.key === currency);
        const currencyValue = selectedCurrency ? selectedCurrency.value : null;

        const result = currencyValue ? Number(amount) / currencyValue : null;
        return result || 0;
    };

    const convertedPrice = !noCalculate ? CurrencyPriceCalculate(price, currencies, currentCurrency) : price;
    return (
        <Styled line={line} fontSize={fontSize} color={color} fontWeight={fontWeight}>
            {(symbol !== 'TRY' || (symbol === 'TRY' && symbolIcon === true)) && (
                <span className="other-symbol">
                    <CurrencyIcon symbol={symbol} />
                </span>
            )}
            <span className="currency-price">
                <span>{NumberFormatInt(convertedPrice)}</span>
                {decimal && symbol !== 'TRY' && <sub>{NumberFormatDec(convertedPrice)}</sub>}

                {symbol === 'TRY' && (
                    <>
                        {TRdecimal && <sub>{NumberFormatDec(convertedPrice)}</sub>}
                        {symbolIcon !== true && <sub className={`tl-text ${TRdecimal ? 'small' : ''}`}>TL</sub>}
                    </>
                )}
                {/* {symbol === 'TRY' && <sub>{NumberFormatDec(convertedPrice)}</sub>}
                {symbol === 'TRY' && symbolIcon !== true && <sub className="tl-text">TL</sub>} */}
            </span>
        </Styled>
    );
};

export default CurrencyPrice;
